module.exports = __webpack_public_path__ + "media/images/test-image/product-item-2481a89a8e13720c192535430cebf075.png";